import { useCallback, PropsWithChildren } from 'react'
import { observer } from 'mobx-react-lite'
import { Badge } from 'antd'

import { favoritesManager } from '../Stores/FavoritesManager'
import { FavoritesDrawer } from '../Components/FavoritesDrawer'

export const useFavoritesDrawer = () => {
    const openFavoritesDrawer = useCallback(() => {
        favoritesManager.setIsDrawerOpen(true)
    }, [])

    const FavoritesBadge = observer(({ children }: PropsWithChildren) => {
        return (
            <Badge
            // count={CounterStore.Favoritess}
            >
                {children}
            </Badge>
        )
    })

    return {
        openFavoritesDrawer,
        FavoritesBadge,
        FavoritesDrawer,
    }
}
